import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { challengeRegistrationPrice } from '../shared/services/fitness-reference-data.service';
import { ChallengeDefinitionEntity } from '../../meta-data/app-meta-data.service';
import { inWindow } from '../shared/pages/home/home-state';
import { StreakerCentralStateService } from './services/streaker-central-state.service';
import { CentralDataService } from './services/central-data.service';

@Component({ selector: 'app-central-dashboard', templateUrl: './central-dashboard.component.html' })
export class CentralDashboardComponent implements OnDestroy {
    private subscription = new Subscription();
    registrationChallenge: ChallengeDefinitionEntity;
    dashboardMode: 'pre-streak' | 'during-streak' = null;
    private dashboardChallengeId: number;
    get currentMode(): string {
        const mode = this.state.state.mode;
        return mode === 'pre-streak' || mode === 'unknown' ? mode
            : this.dashboardMode || (mode === 'after-streak' ? 'during-streak' : mode);
    }
    get registrationPrice(): number { return challengeRegistrationPrice(this.registrationChallenge); }
    get canRegister(): boolean {
        const c = this.registrationChallenge;
        return !!c && this.registrationPrice !== null && inWindow(c.StoreStartDate, c.StoreEndDate, Date.now()) &&
            inWindow(c.RegistrationStartDate, c.RegistrationEndDate, Date.now());
    }
    constructor(public state: StreakerCentralStateService,
        private data: CentralDataService, public route: ActivatedRoute) {
        this.subscription.add(state.state$.subscribe(vm => {
            if (vm.challenge && vm.challenge.ChallengeDefinitionId !== this.dashboardChallengeId) {
                this.dashboardChallengeId = vm.challenge.ChallengeDefinitionId; this.dashboardMode = null;
            }
        }));
        this.subscription.add(this.data.definitions().subscribe(definitions => {
            const active = definitions.filter(challenge => challenge.IsCurrent === true);
            this.registrationChallenge = active.length === 1 ? active[0] : null;
        },
            () => this.registrationChallenge = null));
    }
    invite(): void {
        const target = document.getElementById('central-invitation');
        if (target) { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); document.getElementById('invite-addresses')?.focus({ preventScroll: true }); }
    }
    ngOnDestroy(): void { this.subscription.unsubscribe(); }
}
